// Hero — real loyiha skrinshotlari (public/assets/img/projects/)
const dataSlider = [
  {
    id: 1,
    title: "hero-site",
    desc: "hero-site-desc",
    img: "/assets/img/projects/mesmer.webp",
  },
  {
    id: 2,
    title: "hero-mobile",
    desc: "hero-mobile-desc",
    img: "/assets/img/projects/logistatrans-app.webp",
  },
  {
    id: 3,
    title: "hero-innobek",
    span: "uzbek",
    desc: "hero-innobek-desc",
    img: "/assets/img/projects/grandpharm.webp",
  },
];

export default dataSlider;
